export default __webpack_public_path__ + "static/media/stage.431b648f.jpg";